import { Image as KonvaImage, Layer, Rect, Stage } from 'react-konva';
import type { Frame } from '~/types/pipeline';

type Props = { frame: Frame; source: ImageBitmap; size: number };

export function FrameThumb({ frame, source, size }: Props) {
  const { x, y, w, h } = frame.cellRect;
  const scale = size / Math.max(w, h);
  return (
    // Block pointer events so the canvas doesn't swallow mousedown — lets a
    // draggable parent (e.g. free-mode tile) receive native HTML5 drag.
    <div style={{ pointerEvents: 'none' }}>
      <Stage width={size} height={size}>
        <Layer listening={false}>
          <KonvaImage
            image={source}
            x={0}
            y={0}
            width={w * scale}
            height={h * scale}
            crop={{ x, y, width: w, height: h }}
          />
          <Rect
            x={0}
            y={0}
            width={size}
            height={size}
            stroke="rgba(0,0,0,0.1)"
            strokeWidth={1}
            listening={false}
          />
        </Layer>
      </Stage>
    </div>
  );
}
